export default __webpack_public_path__ + "static/media/bg6.95a17bc0.png";